import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const LocalAPIEndpoint = '/api';

const config : AxiosRequestConfig = {

  baseURL: LocalAPIEndpoint,

  validateStatus(status) {
    return status >= 200 && status < 500; // default
  },

};

const localAPI: AxiosInstance = axios.create(config);

export { localAPI as default, config };
